<script>
import firebase from "firebase";
import store from '../store';

export default {
    name: "client_knowledge",
    data() {
        return {
            showSubcategories: false,
            showAreas: false,
            showEmployees: false,
            category: "",
            subcategory: "",
            area: "",
            subcategories: [],
            areas: [],
            employees: [],
            modalActive: false,
            contactName: "",
            categoryContext: null,
            subcategoryContext: null,
            firmContext: null,
            showModal: false,
            currentUser: null,
            newDesignation: 0,
            inList: false,
            adderoniContext: null,
            firms: null
        }
    },
    created() {
        //console.clear();
        //this.fetchVisits();
    },
    mounted() {
        console.log('component mounted');
        this.fetchFirms();
    },
    destroyed() {
        console.log('component destroyed');
    },
    computed: {
        dark() {
            return store.state.dark;
        },
        exporting() {
            return store.state.exporting;
        },
        exportComplete() {
            return store.state.exportComplete;
        },
        downloadURL() {
            return store.state.downloadURL;
        }
    },
    methods: {
        async fetchVisits() {
            console.log('fetching current count.....');

            await firebase.firestore().collection('metrics').doc('fUWAPfClBOk27OfsjO9Q').get().then((doc) => {
                console.log('doc: ', doc.data())

                this.currentCount = doc.data().kmVisits;

                console.log('currentCount: ', this.currentCount);

                this.updateVisits();
            });
        },
        async updateVisits() {
            console.log('updating count and posting');
            this.currentCount++;

            await firebase.firestore().collection('metrics').doc('fUWAPfClBOk27OfsjO9Q').update({
                kmVisits: this.currentCount
            });

            console.log('newCount: ', this.currentCount);
        },
        wipe(wipeContext) {
            var self = this;

            //console.clear();
            //console.log();
            //console.log("wiping...");
            //console.log();

            let items = document.querySelectorAll(wipeContext);

            console.log('ITEM RENDERED: ');

            items.forEach((item) => {
                //console.log(item);
                //console.log('ARE YOU DARK?:', self.dark);
                
                item.style.backgroundColor = 'transparent';
                item.style.color = ( self.dark ? 'white' : 'black' );
            });
        },
        handleCategoryClick(e) {

            //unhighlight everything else on click
            this.wipe('.wipe');

            console.log('TARGET: ', e.target);

            //highlight on click
            e.target.style.backgroundColor = 'black';
            e.target.style.color = 'white';

            this.categoryContext = e.target.innerHTML.replace("&amp;", "&");

            console.log(this.categoryContext);

            this.showSubcategories = false;
            this.showEmployees = true;
            this.showAreas = false;

            console.log('hiding employees');
            console.log('hiding areas');
            console.log('hiding subcategories');

            var self = this;
            firebase
            .firestore()
            .collection("client_knowledge")
            .where("firm", "==", e.target.innerHTML.replace("&amp;", "&"))
            //.orderBy("subcategory")
            .get().then(function(docs) {
                let rawDoc = [];
                docs.forEach(doc => {
                    rawDoc.push(doc.data());
                })
                //unique subcategories for p]arent category
                self.subcategories = [...new Set(rawDoc.map(x => x.subcategory))];
                //console.log(self.subcategories);
            }).catch(function(error) {
                console.log('Error getting documents: ', error);
            });
        },
        handleSubcategoryClick(e) {

            //unhighlight everything else on click
            this.wipe('.wipe2');

            e.target.style.backgroundColor = 'black';
            e.target.style.color = 'white';

            this.subcategoryContext = e.target.innerHTML.replace("&amp;", "&");

            console.log(this.subcategoryContext);

            this.showAreas = true;
            this.showEmployees = false;
            var self = this;
            firebase
            .firestore()
            .collection("client_knowledge")
            .where("subcategory", "==", e.target.innerHTML.replace("&amp;", "&"))
            //.orderBy("area", "desc")
            .get().then(function(docs) {
                let rawDoc = [];
                docs.forEach(doc => {
                    rawDoc.push(doc.data());
                })
                //unique subcategories for parent category
                self.areas = [...new Set(rawDoc.map(x => x.area))];
                //console.log(self.areas);
            }).catch(function(error) {
                console.log('Error getting documents: ', error);
            });
        },
        handleAreaClick(e) {
            //unhighlight everything else on click

            console.clear();

            console.log('handling area click');

            this.wipe('.wipe');

            e.target.style.backgroundColor = 'black';
            e.target.style.color = 'white';

            this.firmContext = e.target.innerHTML.replace("&amp;", "&");

            console.log(this.firmContext);

            this.currentUser = firebase.auth().currentUser.displayName;

            //console.clear();

            console.log('current user: ', this.currentUser);

            this.showEmployees = true;
            var self = this;

            firebase
            .firestore()
            .collection("client_knowledge")
            .where("firm", "==", e.target.innerHTML.replace("&amp;", "&"))
            //.orderBy("designation", "desc")
            .get().then(function(docs) {
                let rawDoc = [];
                docs.forEach(doc => {
                    rawDoc.push(doc.data());
                })
                //unique subcategories for parent category

                let filtered = [...new Set(rawDoc.filter(x => x.designation >= 1))];
                self.employees = [];

                //manually sort filtered array

                filtered.sort((a, b) => (a.designation > b.designation) ? 1 : -1);
                filtered.reverse();
                console.log('sorted and reversed... ', filtered);

                //updating sorted array

                filtered.forEach((employee) => {
                    self.employees.push(employee);
                });

                //removing duplicates

                self.filterEmployees();
                console.log(self.employees);

                //checking if current user is in the list

                self.inList = false;

                self.employees.forEach((employee) => {
                    console.log(employee.employeeName);

                    if(employee.employeeName == self.currentUser) {
                        self.inList = true;
                    }

                });
                
                //console.log(self.designation);
            }).catch(function(error) {
                console.log('Error getting documents: ', error);
            });
        },
        handleEmployeeClick(e) {
            this.modalActive = true;
            this.contactName = e.target.innerHTML;
        },
        styleRank(target) {
            if(target == 1) {
                return 'rank1';
            }
            else if(target == 2) {
                return 'rank2';
            }
            else { //target == 3
                return 'rank3';
            }
        },
        filterEmployees() {
            var self = this;
            const na = self.employees;

            //console.clear();
            //console.log('new employees array: ', na);

            var sorted = [];
            var trash = [];
        
            na.forEach((item) => {
                if(!trash.includes(item.employeeName)) {
                    sorted.push(item);
                    trash.push(item.employeeName);
                }
            });

            self.employees = sorted;
            console.log('employees filtered... ', self.employees);
        },

        handleDesignationAdd() {
            var self = this;

            console.clear();
            console.log('adding new designation....');

            firebase
            .firestore()
            .collection('client_knowledge')
            .doc().set({
                firm: self.firmContext,
                designation: self.newDesignation,
                employeeName: self.currentUser
            }).then(() => {
                self.showModal = false;
                self.reloadEmployees();
                alert('Added designation of ' + this.newDesignation + ' to ' + this.firmContext + '.');
            });
        },
        handleDesignationUpdate() {
            var self = this;

            console.log('updating designation....');

                firebase
                .firestore()
                .collection('client_knowledge')
                .where('firm', '==', this.firmContext)
                .where('employeeName', '==', this.currentUser)
                .get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        doc.ref.update({
                            designation: self.newDesignation
                        }).then(() => {
                            self.showModal = false;
                            self.reloadEmployees();
                            alert('Updated designation for ' + this.firmContext + '.');
                        });
                    });
                });
        },


        handleDelete() {
            var self = this;

            console.log('handling designation DELETE.......');

            var confirmation = confirm('Are you sure you want to delete your designation for ' + this.firmContext + '?');

            if(confirmation) {
                firebase
                .firestore()
                .collection('client_knowledge')
                .where('firm', '==', this.firmContext)
                .where('employeeName', '==', this.currentUser)
                .get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        doc.ref.delete().then(() => {
                            self.showModal = false;
                            self.reloadEmployees();
                            alert('Successfully removed designation for ' + this.firmContext + '.');
                        });
                    });
                });
            } else {
                alert('Operation canceled');
            }
        },
        handleDesignationCancel() {
            this.showModal = false;
            this.newDesignation = 0;
            console.log('attempted dessie ', this.newDesignation);
            console.log('handling designation cancel');
            console.log('modal visible? ', this.showModal);
        },
        handleEdit() {
            this.adderoniContext = 'edit';
            this.showModal = true;
            console.log(this.adderoniContext);
        },
        handleAdd() {
            console.log('opening modal......');
            this.adderoniContext = 'add';
            this.showModal = true;
            console.log(this.adderoniContext);
        },
        async reloadEmployees() {
            var self = this;

            await firebase
            .firestore()
            .collection("client_knowledge")
            .where("firm", "==", self.firmContext)
            //.orderBy("designation", "desc")
            .get().then(function(docs) {
                let rawDoc = [];
                docs.forEach(doc => {
                    rawDoc.push(doc.data());
                })
                //unique subcategories for parent category

                let filtered = [...new Set(rawDoc.filter(x => x.designation >= 1))];
                self.employees = [];

                //manually sort filtered array

                filtered.sort((a, b) => (a.designation > b.designation) ? 1 : -1);
                filtered.reverse();
                console.log('sorted and reversed... ', filtered);

                //updating sorted array

                filtered.forEach((employee) => {
                    self.employees.push(employee);
                });

                //removing duplicates

                self.filterEmployees();
                console.log(self.employees);

                //checking if current user is in the list

                self.inList = false;

                self.employees.forEach((employee) => {
                    console.log(employee.employeeName);

                    if(employee.employeeName == self.currentUser) {
                        self.inList = true;
                    }

                });
                
                //console.log(self.designation);
            }).catch(function(error) {
                console.log('Error getting documents: ', error);
            });
        },
        async fetchFirms() {
            var self = this;

            await
            firebase
            .firestore()
            .collection('client_knowledge')
            .orderBy("firm")
            .get().then(function(docs) {
                let rawDoc = [];
                docs.forEach(doc => {
                    rawDoc.push(doc.data());
                })
                //unique subcategories for p]arent category
                self.firms = [...new Set(rawDoc.map(x => x.firm))];
                console.log('firms array: ', self.firms);
            }).catch(function(error) {
                console.log('Error getting documents: ', error);
            });
        }

    }
}
</script>

<template>
    <transition name="fade" mode="out-in">

        <div class="page-container" :class="(dark ? 'dark' : '' )">
            <div :class="( modalActive ? 'profile-modal-active' : 'profile-modal-inactive' )">
                <div class="modal-actionbar">
                    <div @click="() => { modalActive = false; }" class="modal-exit">x</div>
                </div>
                <div class="modal-inner">
                    <div class="contact-image"></div>
                    <h1 class="contact-name">{{ contactName }}</h1>
                    <h3>{{ 'example@hbrconsulting.com' }}</h3>
                    <div class="contact-buttons">
                        <a href="maito:#">
                            <div class="email-button contact-button">
                                <div class="email-icon contact-icon"></div>
                            </div>
                        </a>
                        <a href="#">
                            <div class="chat-button contact-button">
                                <div class="chat-icon contact-icon"></div>
                            </div>
                        </a>
                        <a href="https://linkedin.com/userID">
                            <div class="in-button contact-button">
                                <div class="in-icon contact-icon"></div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <div @click="() => { modalActive = false; }" class="page-container-inner" :class="( modalActive ? 'blur' : '' )">
                <div class="cards-container">

                    <ul class="categories km-list km-list-big">
                        <li v-for="(i, index) in firms" :key="index" @click="handleAreaClick"><p class="wipe wipe1 category">{{ i }}</p></li>
                    </ul>

                    <span class="point" v-if="showSubcategories">🡒</span>

                    <ul v-if="showSubcategories" class="subcategories km-list">
                        <p class="no-results" v-if="subcategories.length == 0">No results</p>
                        <li v-for="item in subcategories" :key="item.index">
                            <p class="wipe wipe2" @click="handleSubcategoryClick">{{ item }}</p>
                        </li>
                    </ul>

                    <span class="point" v-if="showAreas">🡒</span>

                    <ul v-if="showAreas" class="areas km-list km-list-big">
                        <li v-for="item in areas" :key="item.index">
                            <p class="wipe wipe3" @click="handleAreaClick">{{ item }}</p>
                        </li>
                    </ul>

                    <span class="point" v-if="showEmployees">🡒</span>

                    <div class="employees-container">
                        <ul v-if="showEmployees" class="employees km-list">
                            <li class="final-items-container" v-for="item in employees" :key="item.index">
                                <p class="final-items" @click="handleEmployeeClick">
                                    <span :class="( item.employeeName == currentUser ? 'me' : '' )" class="employee-name">{{ item.employeeName }}</span>
                                </p>
                                <span class="designation" :class="styleRank(item.designation)">
                                    {{ item.designation }}
                                </span>
                            </li>
                        </ul>
                        <div v-if="showEmployees" class="designation-options">
                            <div v-if="!inList" @click="handleAdd" class="designation-option designation-add">Add designation</div>
                            <div v-if="inList" @click="handleEdit" class="designation-option designation-edit">Edit</div>
                            <div v-if="inList" @click="handleDelete" class="designation-option designation-delete">Delete</div>
                        </div>
                    </div>
                    
                    <div v-if="showModal" class="designation-modal">
                        <h3 class="currentUserName">{{ currentUser }}</h3>
                        <input v-model="newDesignation" type="number" max="3" min="1" class="designation-input" placeholder="0" />
                        <div class="designation-buttons">
                            <div 
                            v-if="adderoniContext == 'add'"
                            :class="( newDesignation <= 3 && newDesignation >= 1 ? 'clickable' : 'not-clickable' )" 
                            class="designation-button submit-button"
                            @click="handleDesignationAdd" 
                            >Add</div>
                            <div 
                            v-if="adderoniContext == 'edit'"
                            :class="( newDesignation <= 3 && newDesignation >= 1 ? 'clickable' : 'not-clickable' )" 
                            class="designation-button submit-button"
                            @click="handleDesignationUpdate" 
                            >Update</div>
                            <div @click="handleDesignationCancel" class="designation-button cancel-button">Cancel</div>
                        </div>
                    </div>
                </div>

                <div class="wd">
                    <h4 class="directory">
                        <span>Firms</span>
                        <span v-if="showSubcategories"> / Subcategories</span>
                        <span v-if="showAreas"> / Area</span>
                        <span v-if="showEmployees"> / Employees</span>
                    </h4>
                    <div @click="exportDB('client_knowledge')" class="export-button">Export Database</div>
                </div>
            </div>

            <div v-if="exporting" class="export-indicator" :style="'background-color: ' + ( exportComplete ? '#58A16D' : 'black' )"><strong>{{( !exporting ? '' : ( exportComplete ? 'Export Complete ✓' : 'Exporting Database...' ) )}}</strong><a :href="downloadURL"><div v-if="exportComplete" class="download-export">Download</div></a></div>
        </div>
    </transition>
</template>

<style scoped lang="scss">
@import '../assets/global-styles/variables';

.me {
    font-weight: bold !important;
    font-style: italic !important;
    opacity: 1 !important;
}

.designation-add {
    background: $colorGreen;
}

.designation-edit {
    background: $colorGreen;
}

.designation-delete {
    background: $colorRed;
}

.designation-option {
    border-radius: 18px;
    text-align: center;
    width: 100%;
    transition: 300ms;
    cursor: pointer;
    line-height: 36px;
    margin: 4px 6px 4px 6px;

    &:hover {
        opacity: 0.4;
    }
}

.designation-options {
    background: green;
    height: 40px;
    margin: 0px;
    border-radius: 0px 0px 18px 18px;
    text-align: center;
    color: white;
    display: flex;
    padding: 6px;
}

.designation-options {
    display: flex;
    background: $colorDarkMid;
}

.option-button {
    background: green;
    color: white;
    cursor: pointer;
    transition: 300ms;
    line-height: 40px;
    height: 40px;
    font-weight: bold;
    text-align: center;
    position: fixed;

    &:hover {
        opacity: 0.4;
    }

}

.clickable {
    opacity: 1;
    filter: contrast(1);
    pointer-events: all;
    cursor: pointer;
}

.not-clickable {
    opacity: 0.6;
    filter: contrast(0.2);
    pointer-events: none;
    cursor: default;
}

.currentUserName {
    font-size: 26px;
    margin-bottom: 32px;
}

.designation-modal {
    background: black;
    position: relative;
    margin: 0px;
    height: 380px;
    width: 280px;
    margin-left: -280px;
    border-radius: 18px;
    animation: flyin forwards ease 300ms;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.designation-buttons {
    //background: purple;
    width: 100%;
    //height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 18px;
    margin-top: 24px;
}

.designation-button {
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-radius: 18px;
    background: gray;
    font-weight: bold;
    cursor: pointer;
    transition: 300ms;
    color: white;
    padding: 4px 24px 4px 24px;
    margin-left: 6px;
    margin-right: 6px;

    &:hover {
        opacity: 0.4;
    }
}

.submit-button {
    background: $colorGreen;
}

.cancel-button {
    background: $colorDarkMid;
}

.designation-input {
    padding: 30px 0px 30px 16px;
    border-radius: 100%;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    border: none;
}

.directory {
    text-align: center;
}

.no-results {
    margin: 24px;
}

.employee-name {
    margin-right: 0px;
    opacity: 0.8;
}

.final-items-container {
    display: flex;
    margin-right: 0px;
    padding-right: 0px;
}

.designation {
    //background: red;
    margin: 0px;
    padding: 2px 8px 2px 8px;
    border-radius: 24px;
    line-height: 24px;
}

.rank1 {
    background: $colorBlue;
    opacity: 0.6;
}

.rank2 {
    background: $colorBlue;
}

.rank3 {
    background: $colorGreen;
}

.contact-name {
    margin-top: 24px !important;
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 0px !important;
}

h3 {
    font-weight: normal;
}

.email-icon {
    background-image: url('../assets/icons/mail-24px.svg');
}

.in-icon {
    background-image: url('../assets/icons/in.png');
}

.chat-icon {
    background-image: url('../assets/icons/chat.jpg');
}

.other-icon {
    background-image: url('../assets/icons/users.svg');
}

.modal-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    //height: calc(100% - 36px);
    margin-top: -140px;
}

.modal-actionbar {
    //background: red;
    display:flex;
    justify-content: flex-end;
    padding: $gap;
    padding-bottom: 0px;
}

.modal-exit {
    border-radius: 100%;
    cursor: pointer;
    padding: 0px 12px 4px 12px;
    //font-weight: bold;
    font-size: 24px;

    //float: right;
    &:hover {
        background: #e0e0e0 !important;
    }
}

.contact-image {
    background-image: url('../assets/icons/profile-blank.svg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 100%;
    height: 124px;
    width: 124px;
    margin-bottom: 18px;
    //box-shadow: $softerShadow;
    //margin-top: -36px;
}

.email-button {
    background: $colorLightBlue !important;
    color: white;
}

.in-button {
    background: $colorBlue !important;
    color: white;
}

.chat-button {
    background: $colorGreen !important;
    color: white;
}

.contact-buttons {
    margin-left: auto;
    margin-right: auto;
    margin-top: $gap;
    cursor: pointer;
}

.contact-button {
    //background: yellow;
    display: block;
    margin-left: 12px;
    margin-right: 12px;
    //margin-top: $gap / 2;
    border-radius: 100%;
    transition: 200ms;
    padding: 6px 18px;
    margin-bottom: 18px;
    background: rgba(0,0,0,0.05);

    span {
        margin-left: 18px;
        margin-right: 18px;
        font-size: 14px;
        margin-bottom: 18px;
    }

    &:hover {
        transform: scale(1.1);
        box-shadow: $softerShadow;
    }

    .contact-icon {
        //background: black;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        height: 30px;
        width: 30px;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: auto;
        margin-right: auto;
        opacity: 1;
        filter:invert(1);
    }
}

.contact-buttons {
    display: flex;
}

.blur {
    opacity: 0.2;
    filter: blur(64px) brightness(0.5);
    pointer-events: none;
}

.profile-modal-active {
    background: white;
    /*display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;*/
    position: absolute;
    z-index: 9999;
    transition: 600ms;
    opacity: 1;
    width: 800px;
    height: 390px;
    top: 80px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    border-radius: $rad;
    margin: auto;
    box-shadow: $softerShadow;
}

.profile-modal-inactive {
    //background: blue;
    /*display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;*/
    position: absolute;
    z-index: 9999;
    transition: 600ms;
    opacity: 0;
    width: 800px;
    height: 390px;
    top: 80px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    border-radius: $rad;
    transform: scale(0.8);
    pointer-events: none;
    margin: auto;
}

.final-items {
    &:hover {
        background: gray !important;
        color: white !important;
    }
}

.point {
    font-size: 24px;
    animation: flyin forwards ease 1s;
}

.dark {
    .page-container-inner {
        background: $colorDarkMid !important;
    }

    .modal-exit {
        &:hover {
            background: $colorDarkLight !important;
        }
    }

    .contact-icon {
        //filter: invert(1) !important;
    }

    .profile-modal-active {
        background: $colorDarkLight !important;
        color: white !important;
    }

    .km-list {
        background: $colorDarkLight !important;
        color: white !important;
        padding-bottom: 24px;
    }

    .li {
        background: $colorDarkLight !important;
        p {
            &:hover {
                background: $colorDarkMid !important;
            }
        }
    }

    .employees {
        background: white !important;
        margin-bottom: 0px !important;
        border-radius: 18px 18px 0px 0px !important;
        margin-top: 6px;
        height: 420px !important;
        
        li {
            p {
                color: black !important;
            }
        }
    }
}

.page-container {
    background: $colorBackdrop;
    flex-direction: column;
}

.page-container-inner {
    background: $colorBackdrop;
    flex-direction: column;
    transition: 400ms;
}

.cards-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.wd {
    margin-top: 64px;
    text-align: center;

    span {
        //animation: flyup ease forwards 1s;
        margin: 0px;
    }
}

ul {
    list-style: none;
    padding-left: 24px;
    padding-bottom: 24px;
}

li {
    cursor: pointer;
    margin-top: 24px;

    p {
        width: max-content;
        padding: 3px 12px;
        border-radius: 48px;
        
        &:hover {
            background: #e0e0e0 !important;
            color: black !important;
        }   
    }
}

.employees {
    background: black !important;
    color: white;
    margin-bottom: 0px !important;
    border-radius: 18px 18px 0px 0px !important;
    margin-top: -6px;
    height: 420px !important;

    p {
        &:hover {
            background: transparent !important;
        }
    }
}

span {
    margin-left: 24px;
    margin-right: 24px;
}

.km-list {
    background: white;
    height: 500px;
    width: 460px;
    overflow:auto;
    border-radius: $rad;
    animation: expand forwards ease 1s;
    //box-shadow: $softerShadow;
}

.km-list-big {
    width: 480px;
    animation: expand2 forwards ease 1s;
}

::-webkit-scrollbar {
  width: 32px;
}

::-webkit-scrollbar-track {
  background: transparent;
  border: none;
}

::-webkit-scrollbar-thumb {
  border: 12px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  -webkit-border-radius: 24px;
  background-color: #eeeeee;
  //-webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
}

.dark-mode::-webkit-scrollbar-thumb {
  background: gray !important;
  border-radius: 24px;
}

p {
    margin: 0px;
}

</style>